/* global jQuery */
import $ from 'jquery';
import 'jquery-once';

// Relative Imports
import Filters from '../../stories/components/filters/filters';

(function ($, Drupal, once) {
    Drupal.behaviors.nhsFilters = {
        attach: function (context, settings) {
            once('nhsFilters', '.views-exposed-form', context).forEach(() => {
                new Filters($);
            })
        }
    };
})($, Drupal, once);
